import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessStagnationResponseService {

  /**
   * コンストラクタ。
   * @memberof BusinessStagnationResponseService
   */
  constructor() { }

  /** 業務閉塞エラー通知イベント用 */
  private errorSubject = new Subject<void>();
  /** 業務閉塞エラー通知受け取り用 */
  public error$ = this.errorSubject.asObservable();

  /**
   * 業務閉塞エラー発生通知メソッド
   * @memberof BusinessStagnationResponseService
   */
  public notifyError(): void {
    this.errorSubject.next();
  }
}
